import React, { useEffect } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import UserActions from '@Actions/userActions';
import loginCreative from '@Images/creative-login.webp';
import logo from '@Images/logo-without-tagline.png';
import { H3_TITLE } from '@Apis/constants';
import Loader from '../Common/Loader';
import LoginFormWrapper from './LoginFormWrapper';
import './style.scss';
/**
 *
 */
function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}

/**
 *
 */
function Login(props) {
  const {
    isAuthenticated, user, getUserProfileLoading, history,
  } = props;

  useDocumentTitle(H3_TITLE);
  const urlParams = new URLSearchParams(window.location.search);
  const callbackUrl = urlParams.get('callback');

  return (
    <React.Fragment>
      {(isAuthenticated) ? (callbackUrl ? <Redirect to={callbackUrl} /> : <Redirect to="/" />) : (
        <React.Fragment>
          {!user && !getUserProfileLoading ? (
            <React.Fragment>
              <div className="login-wrapper">
                <H3Image src={logo} alt="image of procuzy platform" className="login-logo" />
                <div className="login-banner">
                  <H3Image src={loginCreative} alt="image of procuzy platform" />
                  <H3Text
                    text={(
                      <div>
                        Simplify&nbsp;
                        <b>your manufacturing&nbsp;</b>
                        and control&nbsp;
                        <b>company spend&nbsp;</b>
                        with Procuzy
                      </div>
                    )}
                    className="login-banner__text"
                  />
                </div>
                <div className="login-content">
                  <LoginFormWrapper onClickSignup={() => history.push('/signup')} showLogo />
                </div>
              </div>
            </React.Fragment>
          ) : (
            <Loader />
          )}
        </React.Fragment>
      )}

    </React.Fragment>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  requestOtpLoading: UserReducers.requestOtpLoading,
  otpRequestResponse: UserReducers.otpRequestResponse,
  isAuthenticated: UserReducers.isAuthenticated,
  user: UserReducers.user,
  getUserProfileLoading: UserReducers.getUserProfileLoading,
});

const mapDispatchToProps = (dispatch) => ({
  requestOtpError: (error) => dispatch(UserActions.requestOtpError(error)),
});

Login.propTypes = {
  isAuthenticated: PropTypes.bool,
  history: PropTypes.any,
  user: PropTypes.any,
  getUserProfileLoading: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
